import { createClient } from "../../prismicio";
import { useState } from "react";
import Head from "next/head";
import { StudentAgreementForm } from "@/components";

const TrainerAgreementForm = () => {
	const [signStep, setSignStep] = useState(false);

	return (
		<>
			<Head>
				<title>Instructor Training Agreement | Tech Safety Lines</title>
			</Head>
			<main className='studentAgreementMain'>
				<section data-contain='true'>
					<div>
						{!signStep && (
							<StudentAgreementForm
								setSignStep={setSignStep}
								manualForm={true}
							/>
						)}
						{signStep && (
							<>
								<div className='studentAgreementAlertBanner'>
									Please use the email you provided on the previous form to sign
									the agreement.
								</div>
								<iframe
									title='TSL End User Student Agreement Global'
									src='https://www.jotform.com/sign/243424308297055/invite/01jekbpf3s5189ef5ddb4e4e3f?signEmbed=1'
									style={{
										height: "70vh",
										width: "100%",
										border: "0",
									}}></iframe>
							</>
						)}
					</div>
				</section>
			</main>
		</>
	);
};

export default TrainerAgreementForm;

export async function getStaticProps({ previewData }) {
	const client = createClient({ previewData });
	const nav = await client.getSingle("nav");
	const footer = await client.getSingle("footer");

	return {
		props: {
			nav,
			footer,
		},
	};
}
